module.exports = __webpack_public_path__ + "static/media/art-sample-1.2.1a8edf40.png";